<template>
  <div class="ucrs-prevNext">
    <UcrsAnchor
      :to="prev"
      :label="{
        desktop: 'Precedente',
        mobile: 'Prec',
      }"
      role="link"
      aria-label="Annuncio precedente"
      :disabled="!prev"
      icon-position="left"
      icon="angle-left"
      @click="onPrevClick"
    />
    <UcrsAnchor
      class="order-2"
      :to="next"
      :label="{
        desktop: 'Successivo',
        mobile: 'Succ',
      }"
      role="link"
      aria-label="Annuncio successivo"
      :disabled="!next"
      @click="onNextClick"
    />
  </div>
</template>

<script>
// Libs
import { stringify as paramsSerializer } from 'qs'

// Static assets
import { SectionsMap } from '~/assets/js/sections'

// Components
import UcrsAnchor from '~/components/UcrsAnchor.vue'

export default {
  components: {
    UcrsAnchor,
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
      required: true,
    },
  },

  fetchOnServer: false,

  data() {
    return {
      prev: '',
      next: '',
    }
  },
  async fetch() {
    const lastSearch = this.$store.getters['searches/getLast']
    const filter = lastSearch?.filter
    const sort = lastSearch?.sort
    const params = lastSearch ? lastSearch.route.params : this.$route.params
    const { section } = params

    const prevNextRes = await this.$axios.get(
      `/_api/api/v2/property-next-prev/${this.id}`,
      {
        params: {
          section: SectionsMap[section],
          ...(filter ? { filter } : {}),
          ...(sort ? { sort } : {}),
        },
        paramsSerializer,
      }
    )

    const { prev, next } = prevNextRes.data

    this.prev = prev
    this.next = next
  },

  methods: {
    onPrevClick() {
      this.$tealium.track({
        event_name: 'annuncio_precedente',
        link_name: 'annuncio:precedente',
      })
    },

    onNextClick() {
      this.$tealium.track({
        event_name: 'annuncio_successivo',
        link_name: 'annuncio:successivo',
      })
    },
  },
}
</script>

<style lang="postcss">
.ucrs-prevNext {
  @apply absolute md:static left-0 right-0 items-center justify-center text-base font-bold text-blue uppercase;

  &::before {
    @apply block mx-8 h-11 w-0.5 bg-gray-lighter order-1;

    content: '';
  }

  @screen lg {
    @apply text-sm justify-between;

    &::before {
      content: none;
    }
  }
}
</style>
